export default __webpack_public_path__ + "static/2-6e4f2f63b6dcb6b7f999b5bd349fe3f5.png";